import styled from "styled-components";
import { Box } from "theme-ui";
import { themevals } from "theme/themevals";

interface CustomProps extends React.HTMLAttributes<HTMLDivElement> {
	$labelSize?: string;
	width?: string;
	labelColor?: string;
	labelWeight?: string;
}

export const CheckboxWrapper = styled(Box)<CustomProps>`
	--form-check-bg: #fff;	
	--form-check-bg-image: none;

	

	display:flex;
	align-items:center;
	justify-content:flex-start;
	gap: 10px;
	width: ${props => props.width ? props.width : ""};
	label{
		color: ${props => props.labelColor ? props.labelColor : themevals.colors.black};
		font-size:${props => props.$labelSize ? props.$labelSize : "12px"};
		cursor: pointer;
		font-weight: ${props => props.labelWeight ? props.labelWeight : "500"};
		font-family:Poppins;
		flex-direction:column;
		line-height: 22px;
  		user-select: none;
		text-align: left;
		.sublabel{
			font-size: 12px;
			color:${themevals.colors.base_500};
	    }
	}
	
	input {		
    flex-shrink: 0;
    width: 1em;
    height: 1em;
    margin-top: .25em;
    vertical-align: top;
    appearance: none;
    background-color: var(--form-check-bg);
    background-image: var(--form-check-bg-image);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid #D6D6D6;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
	
		border-radius: .25em;
		cursor:pointer;
		border-color:${themevals.colors.mdgrey}
	}

	input:focus{
		box-shadow:none !important;
		border-color:${themevals.colors.base_300};
	}

	input:active {
    filter: brightness(90%);
	}

	input:checked{
		--form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e");
		background-color: ${themevals.colors.body};
		border-color:${themevals.colors.body} !important;
	}
`


